import type { LoginMembershipDto } from "./auth.api.types";
import type { AppUser } from "./authenticated-user";

export type AuthStatus =
  | "idle"
  | "authenticating"
  | "loadingProfile"
  | "authenticated"
  | "refreshing"
  | "unauthenticated"
  | "error";

export interface AuthSessionState {
  requiresRestaurantSelection: boolean;
  loginTicket: string | null;
  memberships: LoginMembershipDto[];
}

export interface AuthState {
  status: AuthStatus;
  /** Populated only after successful GET /auth/v1/me. */
  user: AppUser | null;
  error: string | null;
  profileFetchedAt: string | null;
  /** Session metadata from login — not identity. */
  session: AuthSessionState | null;
}

export const initialAuthState: AuthState = {
  status: "idle",
  user: null,
  error: null,
  profileFetchedAt: null,
  session: null,
};
